import {
  ADD_BLOCKED_NUMBER,
  SET_BLOCKED_NUMBERS,
  REMOVE_BLOCKED_NUMBER,
  SEARCH_BULK_BLOCKED_NUMBER,
  REMOVE_BULK_BLOCKED_NUMBER
} from './mutationTypes';
import { setActionStatusPending, setActionStatusSuccess, setActionStatusError  } from '@/store/helpers';

export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [ADD_BLOCKED_NUMBER](state, blockedNumber) {
    state.blockedNumbers.push(blockedNumber);
  },

  [SET_BLOCKED_NUMBERS](state, blockedNumbers) {
    state.blockedNumbers = blockedNumbers;
  },

  [REMOVE_BLOCKED_NUMBER](state, blockedNumberId) {
    state.blockedNumbers = state.blockedNumbers.filter((blockedNumber) => {
      return blockedNumber.id !== blockedNumberId;
    });
  },

  [SEARCH_BULK_BLOCKED_NUMBER](state, searchResult) {
    state.searchResult = searchResult;
  },

  [REMOVE_BULK_BLOCKED_NUMBER](state) {
    state.numberSearchedBulkBlocked = '';
    state.isNumberSearchedBulkBlocked = false;
  },
};